<template>
  <div class="course_container" v-if="courseData.length">
    <CardTitle :title="data.title" class="card_title" :skipPage="skipSort" />

    <Tabs
      v-model:active="tabActive"
      animated
      title-inactive-color="#999999"
      :color="themeColor"
      line-width="13px"
      :shrink="true"
      v-if="data.code === 'app-category-class'"
      @change="changeTabIndex"
    >
      <Tab v-for="(item, index) in data.lmsDecorateModuleCategories" :key="index" :title="item.categoryName"></Tab>
    </Tabs>

    <div class="list" :class="{ full: isBigList }" v-if="isBigList || isGridList">
      <div class="list_item" v-for="item in courseData" :key="item.id" @click="skipHandle(item)">
        <div class="item_img_wrapper">
          <img class="item_img" :src="item.coverImgUrl" />
          <div class="item_img_tag" v-if="item.learnStatus === 1">
            <span class="tag_text">{{ $t('app_learned_short') }}</span>
          </div>
          <div class="item_img_type">
            <span class="type_text">{{ getFileTypeName(item.fileType) }}</span>
          </div>
        </div>
        <p class="item_text">{{ item.fileName }}</p>
        <p class="item_detail">
          <span class="detail_score">{{ item.score || 0 }}{{ $t('app_score') }}</span>
          <span class="detail_count"> | {{ item.learnNum }}{{ $t('app_people_learned') }}</span>
        </p>
      </div>
    </div>

    <div class="list1" v-if="isSmallList">
      <div class="list_item" v-for="item in courseData" :key="item.id" @click="skipHandle(item)">
        <div class="item_img_wrapper">
          <img class="item_img" :src="item.coverImgUrl" />
          <div class="item_img_tag" v-if="item.learnStatus === 1">
            <span class="tag_text">{{ $t('app_learned_short') }}</span>
          </div>
          <div class="item_img_type">
            <span class="type_text">{{ getFileTypeName(item.fileType) }}</span>
          </div>
        </div>
        <div class="item_text_wrapper">
          <p class="item_text">{{ item.fileName }}</p>
          <div class="item_detail item_detail1">
            <span class="detail_score">{{ item.score || 0 }}{{ $t('app_score') }}</span>
          </div>
          <div class="item_detail">
            <span class="detail_count">{{ item.learnNum }}{{ $t('app_people_learned') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Tabs, Tab } from 'vant'
import { ref, computed } from 'vue'
import CardTitle from './CardTitle.vue'
import { useThemeColor } from '@/utils/theme'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const props = defineProps<{
  data: LmsDecorateModule
}>()

const router = useRouter()
interface TItem {
  fileId: string
  fileType: number
}
const skipHandle = (item: TItem) => {
  router.push({
    name: 'courseDetail',
    query: {
      id: item.fileId,
      courseId: '',
      endingType: 0,
      channel: 0,
      courseType: item.fileType > 0 ? 'courseWare' : 'course'
    }
  })
}

const tabIndex = ref(0)
const changeTabIndex = (index: number) => {
  tabIndex.value = index
}

const courseData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[tabIndex.value].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[tabIndex.value].datas[0].json)
  } catch (error) {
    return []
  }
})
// 首页课程卡片
const skipSort = computed(() => {
  // 0最新 1最热
  return (
    '/course?sortType=' +
    (props.data.lmsDecorateModuleCategories[0].dataShowRule === 0 ? 1 : 3) +
    '&category=' +
    dataJumpCategoryIds.value
  )
})

const dataJumpCategoryIds = computed(() => {
  try {
    return props.data.lmsDecorateModuleCategories[0].dataJumpCategoryIds[0]
  } catch (error) {
    return ''
  }
})

const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).layoutType
  } catch (error) {
    return 3
  }
})

const isSmallList = computed(() => type.value === 1)
const isBigList = computed(() => type.value === 2)
const isGridList = computed(() => type.value === 3)

const themeColor = useThemeColor()

const tabActive = ref(0)

const { t } = useI18n()
const getFileTypeName = (type: number) => {
  // 类型 0:课程,1:文档,2:视频,3:图片
  switch (type) {
    case 0:
      return t('app_course')
    case 1:
      return t('tag_doc')
    case 2:
      return t('tag_video')
    case 3:
      return t('tag_pic')
  }
}
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');
@imgWidth: calc((100vw - 32px - 24px - 10px) / 2);
@imgHeight: calc((100vw - 32px - 24px - 10px) / 2 * 0.58);
@imgHeight2: calc((100vw - 32px - 24px) * 0.58);

:deep(.van-tabs__wrap) {
  // margin-top: -6px;
  margin-left: -14px;
}
:deep(.van-tabs__nav--line) {
  padding-bottom: 8px;
}
.course_container {
  margin: 12px 16px;
  padding: 0 12px;
  border-radius: 8px;
  background-color: @contentBackground;

  .list {
    padding-bottom: 16px;
    display: flex;
    flex-wrap: wrap;
    &.full {
      .list_item {
        width: 100%;
        margin-left: 0 !important;
        .item_img {
          width: 100%;
          height: @imgHeight2;
          border-radius: 5px;
        }
      }
    }
    .list_item {
      width: @imgWidth;
      margin-top: 10px;
      &:nth-child(even) {
        margin-left: 10px;
      }
      .item_img_wrapper {
        position: relative;
      }
      .item_img {
        width: 100%;
        height: @imgHeight;
        border-radius: 5px;
      }
      .item_img_tag {
        // width: 30px;
        height: 16px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: v-bind(themeColor);
        .flex_center;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        .tag_text {
          font-size: 12px;
          transform: scale(0.833);
          color: @textWhite;
        }
      }
      .item_img_type {
        position: absolute;
        bottom: 4px;
        right: 4px;
        border-radius: 3px;
        padding: 1px 2px;
        background-color: rgba(0, 0, 0, 0.4);
        .flex_center;
        .type_text {
          color: @textWhite;
          transform: scale(0.833);
          font-size: 12px;
        }
      }
      .item_text {
        width: 100%;
        margin-top: 8px;
        font-size: 14px;
        color: @textPrimary;
        .text_etc;
      }
      .item_detail {
        margin-top: 6px;
        font-size: 12px;
        .detail_score {
          color: v-bind(themeColor);
        }
        .detail_count {
          color: @textSecondary99;
        }
      }
    }
  }

  .list1 {
    .list_item {
      padding: 14px 0;
      display: flex;
      .border_1px_b;
      .item_img_wrapper {
        flex: 0 0 auto;
        width: 96px;
        height: 56px;
        position: relative;
      }
      .item_img {
        width: 100%;
        border-radius: 5px;
      }
      .item_img_tag {
        // width: 30px;
        height: 16px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: v-bind(themeColor);
        .flex_center;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        .tag_text {
          font-size: 12px;
          transform: scale(0.833);
          color: @textWhite;
        }
      }
      .item_img_type {
        position: absolute;
        bottom: 4px;
        right: 4px;
        border-radius: 3px;
        padding: 1px 2px;
        background-color: rgba(0, 0, 0, 0.4);
        .flex_center;
        .type_text {
          color: @textWhite;
          transform: scale(0.833);
          font-size: 12px;
        }
      }

      .item_text_wrapper {
        width: 0;
        flex: 1;
        margin-left: 10px;
      }
      .item_text {
        width: 100%;
        font-size: 14px;
        color: @textPrimary;
        .text_etc;
      }
      .item_detail {
        margin-top: 4px;
        font-size: 12px;
        &.item_detail1 {
          margin-top: 0;
        }
        .detail_score {
          color: v-bind(themeColor);
        }
        .detail_count {
          color: @textSecondary99;
        }
      }
    }
  }
}
</style>
